module.exports = __webpack_public_path__ + "media/images/icons/SVG/024-b3401bec0999bab424b2e1dc44e874ad.svg";